import React from "react";
import { useTranslation } from "react-i18next";
import {
  Stack,
  Typography,
  Divider,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  TextField,
  IconButton,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ClearIcon from "@mui/icons-material/Clear";
import SubActionButton from "@quest_editor/components/Buttons/SubActionButton";

export type Segment = {
  id: string;
  name: string;
  peopleCount: number;
};

const SegmentTargetField = ({
  segmentRows,
  setSegmentRows,
}: {
  segmentRows: Segment[];
  setSegmentRows: React.Dispatch<React.SetStateAction<Segment[]>>;
}) => {
  const { t } = useTranslation("questEditor");
  const [segmentId, setSegmentId] = React.useState<string>("");

  const handleRemoveSegment = (id: string) => {
    setSegmentRows((prev: Segment[]) => prev.filter((row) => row.id !== id));
  };

  const handleAddBySegmentId = () => {
    if (!segmentId.trim()) return;

    const newSegment: Segment = {
      id: segmentId.trim(),
      name: `リスト${segmentId}`,
      peopleCount: Math.floor(Math.random() * 10000),
    };

    setSegmentRows((prev: Segment[]) => {
      if (prev.some((s) => s.id === newSegment.id)) {
        return prev;
      }
      return [...prev, newSegment];
    });
    setSegmentId("");
  };

  const handleAddByListExtraction = () => {
    console.log("Open list extraction dialog");
  };

  return (
    <Accordion
      sx={{
        ".MuiAccordionSummary-root .MuiSvgIcon-root": {
          transform: "rotate(0deg)",
        },
      }}
    >
      <AccordionSummary expandIcon={<ExpandMoreIcon />}>
        {segmentRows.length > 0 ? (
          <Typography color="primary">
            {segmentRows.map((s) => s.name).join(", ")}
          </Typography>
        ) : (
          <Typography color="primary">
            {t("quest_edit_target.label.not_specified.all_target")}
          </Typography>
        )}
      </AccordionSummary>
      <AccordionDetails>
        <Stack direction="column" divider={<Divider />} spacing={1}>
          {segmentRows.map((row) => (
            <Stack key={row.id} direction="row" alignItems="center" spacing={4}>
              <Typography sx={{ color: "text.secondary", minWidth: 80 }}>
                {row.id}
              </Typography>
              <Typography sx={{ color: "text.secondary", flexGrow: 1 }}>
                {t("quest_edit_target.field.other.number_of_people", {
                  number: row.peopleCount.toLocaleString(),
                })}
              </Typography>
              <IconButton onClick={() => handleRemoveSegment(row.id)}>
                <ClearIcon />
              </IconButton>
            </Stack>
          ))}
          <Stack direction="column" spacing={1}>
            <Stack direction="row" alignItems="center" spacing={1}>
              <TextField
                size="small"
                placeholder={t("quest_edit_target.field.other.placeholder")}
                value={segmentId}
                onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                  setSegmentId(e.target.value)
                }
                sx={{ flexGrow: 1 }}
              />
              <SubActionButton
                onClick={handleAddBySegmentId}
              >
                {t("quest_edit_target.button.add_by_segment")}
              </SubActionButton>
            </Stack>
            <SubActionButton
              onClick={handleAddByListExtraction}
              sx={{ alignSelf: "flex-start" }}
            >
              {t("quest_edit_target.button.add_by_list_extraction")}
            </SubActionButton>
          </Stack>
        </Stack>
      </AccordionDetails>
    </Accordion>
  );
};

export default SegmentTargetField;
